import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {
  closeCompleteDealView,
  submitContentInformation,
  completeContent
} from '../../../store/actions/dealActions';

const styles = theme => ({
  list: {
    width: 550,
    height: 'calc(100% - 150px)',
    [theme.breakpoints.down('xs')]: {
      width: 350
    },
    padding: '50px',
    overflowY: 'scroll'
  },
  shareContentImage: {
    width: '300px',
    marginBottom: '75px'
  },
  contentInput: {
    width: '100%',
    marginBottom: '20px'
  },
  contentInputContainer: {
    textAlign: 'center'
  },
  submitButton: {
    color: 'white',
    marginTop: '30px',
    marginBottom: '50px'
  },
  completeButton: {
    color: 'white',
    marginTop: '56px'
  },
  submitButtonContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '150px',
    background: '#f5f6fa'
  },
  addIcon: {
    marginBottom: '5px',
    marginRight: '5px'
  },
  warningIcon: {
    width: '15px',
    color: 'red'
  },
  infoIcon: {
    width: '15px',
    color: '#e3d402'
  },
  acceptButtonContainer: {
    marginTop: '30px'
  },
  acceptSubmitButton: {
    float: 'right',
    color: 'white'
  },
  messageText: {
    fontSize: '.8em'
  },
  addNewVideoContainer: {
    cursor: 'pointer'
  },
  youtubeVideoUpload: {
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: '30px',
    height: '0',
    overflow: 'hidden',
    '& iframe': {}
  },
  iframeContainer: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%'
  },
  expandPanel: {
    marginBottom: '50px'
  },
  contentContainer: {
    marginBottom: '30px',
    padding: '10px'
  },
  contentLinkContainer: {
    marginTop: '20px',
    fontWeight: 'bold'
  },
  contentLink: {
    color: 'black !important'
  }
});

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    open: state.dealState.viewCompleteDealForm,
    deal: state.dealState.dealToComplete
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    closeClick: () => dispatch(closeCompleteDealView()),
    submitContentInformationHandler: (
      contentLink,
      videoId,
      dealId,
      currentUid
    ) =>
      dispatch(
        submitContentInformation(contentLink, videoId, dealId, currentUid)
      ),
    completeContentHandler: (dealId, userId) =>
      dispatch(completeContent(dealId, userId))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withProps(({ auth }) => ({
    auth
  })),
  withRouter,
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/deals/complete-deal-form/CompleteDealForm.enhancer.js